<template>
    <!-- https://www.svgrepo.com/svg/506518/language?edit=true -->
    <svg
        fill="#F09A0FFF"
        width="800px"
        height="800px"
        viewBox="0 0 64 64"
        id="Layer_1_1_"
        version="1.1"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <g id="SVGRepo_bgCarrier" stroke-width="0" />

        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

        <g id="SVGRepo_iconCarrier">
            <g>
                <path
                    d="M61,53V18c0-2.757-2.243-5-5-5H43V4c0-1.654-1.346-3-3-3H14c-1.654,0-3,1.346-3,3v9H8c-2.757,0-5,2.243-5,5v35H1v5 c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5v-5H61z M56,15c1.654,0,3,1.346,3,3v35h-2V19c0-1.103-0.897-2-2-2H43v-2H56z M23,55h18 v1c0,0.552-0.449,1-1,1H24c-0.551,0-1-0.448-1-1V55z M9,53V19h2v1c0,1.654,1.346,3,3,3h7.182C21.069,23.318,21,23.652,21,24v16 c0,1.654,1.346,3,3,3h9v5.805L42.287,43H50c1.654,0,3-1.346,3-3V24c0-1.654-1.346-3-3-3h-7.184C42.928,20.686,43,20.352,43,20v-1 h12v34H9z M50,23c0.551,0,1,0.448,1,1v16c0,0.552-0.449,1-1,1h-8.287L35,45.195V41H24c-0.551,0-1-0.448-1-1V24 c0-0.061,0.024-0.116,0.034-0.174L31,28.805V23h8.064H40H50z M13,4c0-0.552,0.449-1,1-1h26c0.551,0,1,0.448,1,1v16 c0,0.552-0.449,1-1,1h-0.936H29v4.195L22.287,21H14c-0.551,0-1-0.448-1-1V4z M5,18c0-1.654,1.346-3,3-3h3v2H9c-1.103,0-2,0.897-2,2 v34H5V18z M61,58c0,1.654-1.346,3-3,3H6c-1.654,0-3-1.346-3-3v-3h18v1c0,1.654,1.346,3,3,3h16c1.654,0,3-1.346,3-3v-1h18V58z"
                />
                <rect height="2" width="2" x="7" y="57" />
                <rect height="2" width="2" x="11" y="57" />
                <rect height="2" width="2" x="15" y="57" />
                <rect height="2" width="24" x="15" y="5" />
                <rect height="2" width="24" x="15" y="9" />
                <rect height="2" width="2" x="37" y="13" />
                <rect height="2" width="20" x="15" y="13" />
                <rect height="2" width="2" x="26" y="17" />
                <rect height="2" width="2" x="32" y="17" />
                <rect height="2" width="2" x="20" y="17" />
                <rect height="2" width="16" x="33" y="25" />
                <rect height="2" width="16" x="33" y="29" />
                <rect height="2" width="2" x="47" y="33" />
                <rect height="2" width="20" x="25" y="33" />
                <rect height="2" width="2" x="36" y="37" />
                <rect height="2" width="2" x="42" y="37" />
                <rect height="2" width="2" x="30" y="37" />
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "Language2",
};
</script>

<style scoped></style>
